module.exports = __webpack_public_path__ + "img/logoCJ.d13770ea.png";